export const IOC_COMPARE = { id: 'ioc_compare', name: 'ioc', loadable: false };
export const NIRI_COMPARE = { id: 'niri_compare', name: 'niri', loadable: false };
